(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["aura-product-facts"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('aura-product-facts')){customElements.define('aura-product-facts',class extends HTMLElement{
 connectedCallback(){
 if(this.dataset.ready)return;this.dataset.ready='true';
 const source=this.querySelector('template').content.cloneNode(true);const list=this.querySelector('[data-facts-list]');const found=new Set();
 source.querySelectorAll('br').forEach(el=>el.replaceWith(document.createTextNode('\n')));
 source.querySelectorAll('p,li,td').forEach(el=>{el.textContent.split('\n').forEach(line=>{const text=line.replace(/^[\s•·–-]+/,'').trim();const match=text.match(/^(Material|Diameter(?: \(?approximate\)?)?|Dimensions|Measurements|Size|Quantity|Package contents|Shape|Format|Thickness|Diâmetro(?: aproximado)?|Dimensões|Medidas|Tamanho|Quantidade|Conteúdo(?: da embalagem)?|Formato|Espessura)\s*:/i);if(match&&text.length<240&&found.size<6&&!found.has(match[1].toLowerCase())){found.add(match[1].toLowerCase());const li=document.createElement('li');li.textContent=text;list.append(li);}})});
 if(found.size)this.querySelector('[data-facts-panel]').hidden=false;
 this.querySelector('[data-facts-open]').addEventListener('click',()=>{const details=document.getElementById(this.querySelector('a').hash.slice(1));if(details)details.open=true;});
 }
});}
  } catch(e) { console.error(e); }
})();

})();
